<canvas
  #riveCanvas
  rive
  class="loading-sensei"
  loading="lazy"
  [riveFile]="'assets/images/post-activity/sensei_waiting.riv'"
  [artboard]="'Neutral'"
  [stateMachine]="'State Machine 1'"
  [autoplay]="true"
  width="750"
  height="750"
></canvas>

<img src="assets/images/character_shadow.svg" class="loading-character-shadow" />
<div class="mb-4">
  <div class="screen-header" #messageText></div>
  <div class="screen-message">{{ staticMessageKey | transloco }}</div>
</div>
